import { render, staticRenderFns } from "./ResetDialog.vue?vue&type=template&id=1f0fd992&"
import script from "./ResetDialog.vue?vue&type=script&lang=js&"
export * from "./ResetDialog.vue?vue&type=script&lang=js&"
import style0 from "./ResetDialog.vue?vue&type=style&index=0&id=1f0fd992&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports